import * as React from "react";
import styled from "styled-components";
import IconButton from "components/common/IconButton";
import MessageField from "views/components/messagelist/MessageField";
import CustomHighlighting from "views/components/highlighting/CustomHighlighting";
import HoverForHelp from "components/common/HoverForHelp";
import { isArrayValue } from "search/messageFieldValueHelper";
const Container = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.table.variant.danger};
  display: flex;
  padding: ${theme.spacings.xxs};
  border-radius: 3px;

  &:not(last-child) {
    margin-bottom: ${theme.spacings.xxs};
  }
`
);
const FieldsCol = styled.div(
  ({ theme }) => `
  padding: 2px;
  color: black;
  flex: 1;
  color: ${theme.colors.gray[30]};
`
);
const ActionsCol = styled.div`
  padding: 2px;
`;
const MatchDetail = styled.div(
  ({ theme }) => `
  font-size: ${theme.fonts.size.small};
  color: ${theme.colors.gray[40]};
`
);
const StyledHoverForHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin: 3px 8px;
`;
const WatchlistIndicator = ({
  allowRemoval,
  title,
  watchlistName = void 0,
  matchedEntry = void 0,
  matchedViaRange = false,
  fieldName,
  fieldValue,
  realFieldType,
  onDelete,
  message
}) => {
  const isArrayFieldValue = isArrayValue(fieldValue);
  return /* @__PURE__ */ React.createElement(Container, { title }, /* @__PURE__ */ React.createElement(FieldsCol, null, /* @__PURE__ */ React.createElement(CustomHighlighting, { key: fieldName, field: fieldName, value: fieldValue }, /* @__PURE__ */ React.createElement(MessageField, { fieldName, fieldType: realFieldType, message, value: fieldValue })), /* @__PURE__ */ React.createElement(MatchDetail, null, "On watchlist: ", watchlistName != null ? watchlistName : title), matchedViaRange && matchedEntry && /* @__PURE__ */ React.createElement(MatchDetail, null, "Matched range: ", matchedEntry)), allowRemoval && !isArrayFieldValue && /* @__PURE__ */ React.createElement(ActionsCol, null, /* @__PURE__ */ React.createElement(IconButton, { name: "delete", onClick: onDelete, title: `Remove from ${title}` })), allowRemoval && isArrayFieldValue && /* @__PURE__ */ React.createElement(StyledHoverForHelp, { title: "Deletion not possible" }, "This field value is an array, at least one value is on the ", title, ". Removing multiple values from a watchlist is currently not supported. If you want to remove the values you can manually edit the watchlist."));
};
export default WatchlistIndicator;
